import type { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

import background from './assets/background.webp';

const Root = styled.div`
  isolation: isolate;
`;

const BackgroundElement = styled.div`
  position: fixed;
  isolation: isolate;
  inset: 0;
  z-index: -1;
  background:
    linear-gradient(
      to bottom,
      rgba(var(--bg-color), 0.7),
      rgba(var(--bg-color), 0.7)
    ),
    url(${background}) no-repeat center / cover;
  background-blend-mode: multiply, normal;
`;

type Props = {
  children: ReactNode;
};
export const Background = ({ children }: Props) => {
  return (
    <Root>
      <BackgroundElement
        style={
          {
            '--bg-color': 'var(--c-rgb-set-surface-tertiary)',
          } as CSSProperties
        }
      />
      {children}
    </Root>
  );
};
